var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3524_15675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56719 7.30322L7.60312 10.4907H10.9547L8.24531 12.4642L9.28125 15.6517L6.56719 13.6829L3.85313 15.6517L4.89375 12.4642L2.17969 10.4907H5.53125L6.56719 7.30322Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.227 18.586L13.4348 17.611L12.2629 18.0657L12.9426 17.011L12.1504 16.0313L13.3645 16.3547L14.0488 15.3L14.1145 16.5563L15.3332 16.8797L14.1566 17.3297L14.227 18.586Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.802 15.7266L16.177 14.5266L15.1504 13.8L16.4066 13.7813L16.777 12.5813L17.1848 13.7719L18.441 13.7579L17.4332 14.5079L17.8363 15.6985L16.8098 14.9719L15.802 15.7266Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9246 8.80796L17.3715 9.93765L18.2715 10.8142L17.0293 10.6361L16.4762 11.7611L16.2605 10.5236L15.0137 10.3455L16.1293 9.75952L15.9137 8.51733L16.8137 9.3939L17.9246 8.80796Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2602 5.38599L14.1664 6.63755L15.3336 7.11099L14.1102 7.41099L14.0211 8.66724L13.3602 7.59849L12.1367 7.89849L12.9477 6.93755L12.282 5.87349L13.4492 6.34692L14.2602 5.38599Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3524_15675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCny);
export default __webpack_public_path__ + "static/media/CNY.e24e7ca7938eea4f3a063a68bd18a93f.svg";
export { ForwardRef as ReactComponent };